import { render, staticRenderFns } from "./SubmitReplacementsNew.vue?vue&type=template&id=f2953786&"
import script from "./SubmitReplacementsNew.vue?vue&type=script&lang=js&"
export * from "./SubmitReplacementsNew.vue?vue&type=script&lang=js&"
import style0 from "./SubmitReplacementsNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports